import React, { useState } from "react";
import { Trans } from "@lingui/macro";

import loadable from "@loadable/component";
import { ResponsiveSanityImage } from "@silversea-ssc/ui-components-react";
import { Button } from "@silversea-ssc/ui-components-react";
import SeeAllCruisesButton from "./SeeAllCruisesButton";
import { DestinationPageQuery } from "types/graphql-types";
const VideoModal = loadable(() => import("../../Video/VideoModal"));
import * as styles from "./Herospace.module.scss";
import { SectionContainer } from "@silversea-ssc/ui-components-react";
import { FYCQuery } from "components/FindYourCruise/FYCQueryBuilder";
import { SearchClient } from "algoliasearch";

export type HerospaceModel = DestinationPageQuery["destination"] & {
  searchClient: SearchClient;
  initialSearchQuery: FYCQuery;
  defaultSearchIndexName: string;
};

const Herospace: React.FC<HerospaceModel> = (props) => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <div id="hero" className={styles.herospace} data-content-name="hero">
      {isVideoOpen && props.video?.file && (
        <VideoModal
          onRequestClose={() => setIsVideoOpen(false)}
          videoFile={props.video?.file}
          trackingTitle={props.video?.trackingTitle}
        />
      )}
      {props.heroImage && (
        <ResponsiveSanityImage
          image={props.heroImage}
          className={styles.backgroundImage}
          defaultWidth={3000}
          defaultHeight={675}
        />
      )}
      <div className={styles.contentBox}>
        <SectionContainer backgroundColor="transparent">
          <div className={styles.content}>
            <header className={styles.header}>
              <h2 className={styles.title}>{props.name?.localized}</h2>
              <h3 className={styles.subtitle}>{props.title?.localized}</h3>
            </header>
            <div className={styles.infos}>
              <div className={styles.info}>
                <Button
                  variant="link"
                  href="#luxuryShips"
                  data-content-piece="ANCHOR-LUXURY-SHIPS"
                >
                  {props.featureText1?.localized}
                </Button>
              </div>
              <div className={styles.info}>
                <Button
                  variant="link"
                  href="#allInclusive"
                  data-content-piece="ANCHOR-ALL-INCLUSIVE"
                >
                  {props.featureText3?.localized}
                </Button>
              </div>
            </div>
            {props.video?.file && (
              <footer className={styles.contentBoxFooter}>
                <Button
                  renderAs="button"
                  onClick={() => setIsVideoOpen(true)}
                  variant="primary"
                  iconName="play"
                  data-content-piece="FullWidthVideoClick_Antarctica21"
                >
                  <Trans id="watch the video">Watch The Video</Trans>
                </Button>
              </footer>
            )}
          </div>
        </SectionContainer>
      </div>
      <div className={styles.footer}>
        <SeeAllCruisesButton
          className={styles.seeAllCruisesButton}
          searchClient={props.searchClient}
          initialSearchQuery={props.initialSearchQuery}
          defaultSearchIndexName={props.defaultSearchIndexName}
          destinationName={props.name?.localized}
        />
      </div>
    </div>
  );
};

export default Herospace;
